import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import * as actions from "./redux/actions"
import { PropertiesMap } from "./index"
import { PropertiesDrilldown } from "./index"

export class DefaultPage extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  }

  render() {
    return (
      <div className="home-default-page">
        <div className="app-content">
          <div className="app-content_middle home-properties-map">
            <PropertiesMap />
          </div>

          <PropertiesDrilldown />
        </div>
      </div>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  home: state.home,
})

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...actions }, dispatch),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DefaultPage)



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js